module.exports = __webpack_public_path__ + "img/img_xiakuan@2x.5899aa7e.png";